module.exports = __webpack_public_path__ + "img/9x2.8d56f679.png";